import {Component, OnInit, ViewChild} from '@angular/core';
import {ModalController} from '@ionic/angular';
import {SaveMessage} from '../../../_helpers/save-message';
import {Movimento} from '../../../_models/Movimento';
import {Contenitore} from '../../../_models/Contenitore';
import {SearchResult} from '../../../_models/SearchResult';
import {OrdineEsolver} from '../../../_models/OrdineEsolver';
import {LocalService} from '../../../_services/local.service';
import {OrganizzazioniService} from '../../../_services/organizzazioni.service';
import {constants} from '../../../_helpers/constants';
import {MovimentiService} from '../../../_services/movimenti.service';
import {MessageConfirm} from '../../../_helpers/message-confirm.service';
import {AuthenticationService} from '../../../_services/authentication.service';
import {LicenzeService} from '../../../_services/licenze.service';
import {BoxInputComponent} from '../../input/box-input/box-input.component';
import {SelezionaFaseContoLavoroModalComponent} from '../seleziona-fase-conto-lavoro-modal/seleziona-fase-conto-lavoro-modal.component';

@Component({
    selector: 'app-documento-magazzino-add-contenitori',
    templateUrl: './documento-magazzino-add-contenitori.component.html',
    styleUrls: ['./documento-magazzino-add-contenitori.component.scss'],
    standalone: false
})
export class DocumentoMagazzinoAddContenitoriComponent implements OnInit {
  @ViewChild('scannerBox') scannerBox?: BoxInputComponent;
  idSpedizione: number;
  idAnagrafica: number;
  codPallet: string;
  pallet: Contenitore = {
    id: 0, codice: '', descrizione: '', isActive: true, tara: 0, 
    giacenza: 0, giacenzaUdM2: 0, organizzazioneId: 0, formato: 0, 
    tipoBox: 0, udM2: 'KG', udM: 'NR'
  };
  movimenti: Movimento[] = [];
  loading: boolean = false;
  verificaCodArt: boolean = true;
  protected readonly constants = constants;
  constructor(
    public authService: AuthenticationService,
    public licenseService: LicenzeService,
    private organizzazioneService: OrganizzazioniService,
    private movimentiService: MovimentiService,
    private modalCtrl: ModalController,
    private localService: LocalService,
    private saveMessage: SaveMessage,
    private deleteConfirm: MessageConfirm) { }

  ngOnInit() {
    this.pallet.codice = this.codPallet ?? '';
    this.pallet.organizzazioneId = this.organizzazioneService.organizzazioneId;
    if (this.organizzazioneService.currentOrganizzazioneSubject.value) {
      this.pallet.formato = this.organizzazioneService.currentOrganizzazioneSubject.value.boxFormatoInve ?? 0;
    }
    if (this.movimenti.length > 0) {
      this.movimenti.forEach((movimento: Movimento) => {
        this.pallet.tara += movimento.tara;
        this.pallet.giacenza += movimento.quantita;
        this.pallet.giacenzaUdM2 += movimento.quantitaUdM2;
      });
    }
  }

  get movimentiNonValidi(): number {
    return this.movimenti.filter(m => m.quantita <= 0).length;
  }
  
  selPallet = (contenitore: Contenitore) => this.pallet = contenitore;
  
  addContenitore(contenitore: Contenitore) {
    if (this.movimenti.some(m => m.codBox === contenitore.codice)) {
      this.focusScanner();
      return;
    }
    if (!contenitore || !contenitore.rifOdP) {
      this.saveMessage.messageError("Contenitore inesistente o senza ordine collegato.");
      this.focusScanner();
      return false;
    }
    this.addMovimento(contenitore);
  }

  addMovimento(contenitore: Contenitore) { 
    const movimento: Movimento = {
      organizzazioneId: this.organizzazioneService.organizzazioneId,
      id: 0,
      dataUnixRegistrazione: Math.floor(new Date().getTime() / 1000),
      rifOdP: contenitore.rifOdP, // ordine.rifOdP,
      idRigaMateriale: 0,
      codArt: contenitore.codArt,
      varianteArt: contenitore.varianteArt,
      unitaMisura: contenitore.udM, // ordine.udM,
      magUdM: contenitore.udM, // ordine.udM,
      quantita: contenitore.giacenza,
      coeffX1: 1,
      codLottoAlfa: contenitore.codLottoAlfa,
      codMagazzinoOut: contenitore.codMagazzino,
      codMagAreaOut: contenitore.codMagArea,
      codMagazzinoIn: 'EST-'+this.idAnagrafica.toString(), 
      codMagAreaIn: '', 
      codBox: contenitore.codice,
      parentBox: this.pallet.codice,
      contesto: 4,  // Invio a Terzista
      codLav: '', 
      tipoMovimento: 1,
      tipoQuantita: contenitore.tipoBox, 
      currentGiacenza: 0,
      currentGiacenzaUdM2: 0,
      udM2: contenitore.udM2, 
      quantitaUdM2: contenitore.giacenzaUdM2,
      rifDocumento: '', 
      dataDocumento: new Date(),
      idAnagrafica: this.idAnagrafica,
      saldaRiga: false,
      idSpedizione: this.idSpedizione,
      executedBy: this.authService.currentUserValue.userName
    };

    this.movimenti.push(movimento);
    if (movimento.rifOdP){
      this.setOrdineToMovimento(movimento, true);
    }
  }

  setOrdineToMovimento(movimento: Movimento, focusScannerOnComplete = false) {
    this.loading = true;
    movimento.rifDocumento = '';
    const codArt = this.verificaCodArt ? movimento.codArt : undefined;
    this.localService.getOrdiniTerzisitByRifOdPAsync(this.organizzazioneService.organizzazioneId,
      movimento.rifOdP, codArt)
      .then((_ordini: SearchResult<OrdineEsolver>) => this.abbinaFaseContoLavoro(movimento, _ordini))
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il caricamento degli ordini conto lavoro."))
      .finally(() => {
        this.loading = false;
        if (focusScannerOnComplete) {
          this.focusScanner(150);
        }
      });
  }

  // Sceglie la fase conto lavoro da abbinare al movimento.
  // verificaCodArt attivo: logica a due rami — "stesso RifOdP" ha priorità, "distinta" è il fallback.
  // verificaCodArt disattivato: la logica a due rami è bypassata, con più fasi l'operatore sceglie.
  private abbinaFaseContoLavoro(movimento: Movimento, ordini: SearchResult<OrdineEsolver>) {
    const fasi = ordini?.result ?? [];
    if (fasi.length === 0) {
      this.segnalaFaseNonTrovata(movimento);
      return;
    }

    if (!this.verificaCodArt) {
      if (fasi.length === 1) {
        this.applicaFaseAlMovimento(movimento, fasi[0]);
      } else {
        void this.selezionaFaseContoLavoro(movimento, fasi);
      }
      return;
    }

    const stessoRifOdP = fasi.filter(f => f.rifOdP === movimento.rifOdP);
    if (stessoRifOdP.length === 1) {
      this.applicaFaseAlMovimento(movimento, stessoRifOdP[0]);
      return;
    }
    if (stessoRifOdP.length > 1) {
      void this.selezionaFaseContoLavoro(movimento, stessoRifOdP);
      return;
    }

    // Ramo "stesso RifOdP" senza candidate: fallback sul ramo "distinta" (RifOdP diverso)
    const distinta = fasi.filter(f => f.rifOdP !== movimento.rifOdP);
    if (distinta.length > 0) {
      const faseDistinta = distinta.reduce((min, f) => (f.numFase < min.numFase ? f : min));
      this.applicaFaseAlMovimento(movimento, faseDistinta);
      return;
    }

    this.segnalaFaseNonTrovata(movimento);
  }

  private applicaFaseAlMovimento(movimento: Movimento, fase: OrdineEsolver) {
    movimento.rifOdP = fase.rifOdP;
    movimento.unitaMisura = fase.udM;
    movimento.magUdM = fase.udM;
    movimento.udM2 = fase.udM2;
    movimento.codLav = fase.lavorazione;
    movimento.rifDocumento = fase.rifOrdine;
    movimento.dataDocumento = fase.dataRegistrazione;
  }

  private async selezionaFaseContoLavoro(movimento: Movimento, fasi: OrdineEsolver[]) {
    const modal = await this.modalCtrl.create({
      component: SelezionaFaseContoLavoroModalComponent,
      componentProps: {fasi}
    });
    await modal.present();
    const {data, role} = await modal.onWillDismiss();
    if (role === 'confirm' && data) {
      this.applicaFaseAlMovimento(movimento, data as OrdineEsolver);
    }
  }

  private segnalaFaseNonTrovata(movimento: Movimento) {
    // rifDocumento resta vuoto: il movimento NON è associato a una fase conto lavoro (evidenziato in rosso nella UI)
    this.saveMessage.messageError(
      `Nessuna fase conto lavoro corrispondente per ${movimento.codBox}: il movimento non è stato associato.`);
  }
  
  removeMovimento = (movimento: Movimento) => {
    this.deleteConfirm
      .presentAlert(`Sei sicuro di voler eliminare movimento di ${movimento.codBox}?`, () => {
        if (movimento.id > 0) {
          this.movimentiService.deleteMovimentoAsync(this.organizzazioneService.organizzazioneId, movimento.id)
            .then(() => this.movimenti = this.movimenti.filter((_mov: Movimento) => _mov !== movimento))
            .catch(() => this.saveMessage.messageError("Ci sono problemi con l'eliminazione del movimento."));
        } else {
          this.movimenti = this.movimenti.filter((_mov: Movimento) => _mov !== movimento);
        }    
      });
  };
    
  updateQta() {
    this.pallet.giacenza = this.movimenti.reduce((totale, movimento) => totale + movimento.quantita, 0);
    this.movimenti.forEach((movimento: Movimento) => {
      movimento.quantitaUdM2 = (this.pallet.giacenzaUdM2 / this.pallet.giacenza) * movimento.quantita;
      movimento.tara = this.pallet.tara / this.movimenti.length; // (this.pallet.tara / this.pallet.giacenza) * movimento.quantita;
      movimento.parentBox = this.pallet.codice;
      movimento.udM2 = 'KG';
    });
    this.movimenti = [...this.movimenti];
  }
  
  confirmRiga = () => {
    this.deleteConfirm.presentAlert(`Confermi ${this.pallet.giacenzaUdM2} KG in ${this.movimenti.length} contenitori?`, () => this.confirm());
  }

  confirm() {
    this.updateQta();
    this.movimenti.forEach((movimento: Movimento) => {
      if (movimento.id > 0) {
        this.movimentiService.updateMovimentoAsync(movimento)
          .catch(() => this.saveMessage.messageError("Ci sono problemi con la creazione del movimento."))
          .finally(() => this.loading = false);
      } else {
        this.movimentiService.createMovimentoAsync(movimento)
          .catch(() => this.saveMessage.messageError("Ci sono problemi con la creazione del movimento."))
          .finally(() => this.loading = false);  
      }
    });
    this.movimentiService.updateContenitoreAsync(this.pallet)
      .then(() => {
        this.saveMessage.messageInfo('Richiesta di salvataggio inviata. Le notifiche confermeranno il completamento.', true);
        return this.modalCtrl.dismiss(this.movimenti, 'confirm');
      })
      .catch(() => this.saveMessage.messageError("Ci sono problemi con il salvataggio del pallet."));
  };
  cancel = () =>  this.modalCtrl.dismiss(false, 'cancel');

  private focusScanner(delay = 0) {
    window.setTimeout(() => {
      void this.scannerBox?.codBoxInput?.setFocus();
    }, delay);
  }
}
